/**
 * Mask a phone number for on-screen display while still allowing the underlying
 * tel: link to place a real call. Shows the first 2 and last 2 digits, e.g.:
 *   "0910000099"      → "09••••99"
 *   "+218910000099"   → "+218 91••••99"
 * The full number is what you pass to `<a href={`tel:${phone}`}>`; only the
 * label is masked.
 */
const KNOWN_CC_PREFIXES = ["+218", "+20", "+90", "+971", "+966"];

export function maskPhone(phone) {
  if (!phone) return "";
  const raw = String(phone).trim();
  if (!raw) return "";
  let prefix = "";
  let rest = raw;
  if (rest.startsWith("+")) {
    const digits = rest.replace(/\D/g, "");
    // Try known country codes first (favor exact match over greedy regex).
    for (const cc of KNOWN_CC_PREFIXES) {
      const ccDigits = cc.slice(1);
      if (digits.startsWith(ccDigits)) {
        prefix = cc + " ";
        rest = digits.slice(ccDigits.length);
        break;
      }
    }
    if (!prefix) {
      // Fallback: assume 3-digit country code.
      prefix = "+" + digits.slice(0, 3) + " ";
      rest = digits.slice(3);
    }
  } else {
    rest = rest.replace(/\D/g, "");
  }
  if (rest.length <= 4) return prefix + rest;
  const head = rest.slice(0, 2);
  const tail = rest.slice(-2);
  const dotCount = Math.max(2, Math.min(4, rest.length - 4));
  return `${prefix}${head}${"•".repeat(dotCount)}${tail}`;
}
